// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"300e109d","732":"41066ee9"}[chunkId] + ".chunk.js";
};